import { render, staticRenderFns } from "./IpWhitelistView.vue?vue&type=template&id=24b4d1ad&"
import script from "./IpWhitelistView.vue?vue&type=script&lang=ts&"
export * from "./IpWhitelistView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports